import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Btn from 'components/buttons/Btn'
import Tip from 'components/Tip'
import { map } from 'lodash-es'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { ButtonGroup, Dropdown, ListGroupItem } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { toggleItem } from 'state/Items'
import MenuItem from 'state/models/MenuItem'
import { klass, usePlainEffect } from 'utils'

/** @param item {MenuItem} */
export default function ItemRow({ item }) {
	const { t }    = useTranslation()
	const dispatch = useDispatch()

	//keeping an internal state to have an optimistic switch; it's a small action and could be repeated in the page
	const [status, setStatus] = useState(item.shown_status)

	//updates the internal state in case the Refresh button is pressed and some status changed externally
	usePlainEffect(() => setStatus(item.shown_status), [setStatus, item.shown_status])

	function doChange(status) {
		return () => {
			const oldStatus = item.shown_status
			if (oldStatus == status) { //in case the user clicks the current state, just close the dropdown
				return
			}
			setStatus(status)
			dispatch(toggleItem(item, status))
				.catch(() => setStatus(oldStatus)) //optimistic call, so we toggle back in case of failures
		}
	}

	let statusTitle = ''
	if (!item.has_category) {
		statusTitle = t('Can\'t change status; this item has no category')
	} else if (item.shown_prices_count !== undefined && item.shown_prices_count === 0) {
		statusTitle = t('Can\'t change status; this item has no visible prices')
	}
	const disabled = !!statusTitle

	const StatusIcon = <FontAwesomeIcon icon={MenuItem.STATUS_UI[status].icon} fixedWidth/>
	const Buttons    = <>
		<Btn variant="light" as={Link} to={`/item/${item.id}`} icon="pencil-alt" title={t('Edit item')}/>
		<Btn variant="light" as={Link} to={`/item/${item.id}/image`} icon="camera" title={t('Upload photo')}/>
	</>

	return <ListGroupItem>
		<span className="text-bold-reset">{item.display_name_with_HTML}</span>

		{statusTitle?
			<span className="plain-status">
				{StatusIcon} <Tip.Bubble xs text={statusTitle}/>
				<ButtonGroup>{Buttons}</ButtonGroup>
			</span>
		:
			<ButtonGroup>
				<Dropdown>{/* could be replaced by DropdownButton, but then classes won't work in the button */}
					<Dropdown.Toggle className={MenuItem.STATUS_UI[status].className} id={`dropdown-status-${item.id}`}
					                 variant="light" disabled={disabled}>
						{StatusIcon}
					</Dropdown.Toggle>
					<Dropdown.Menu>
						{map(MenuItem.STATUS_UI, ({ icon, className, text }, optStatus) => (
							<Dropdown.Item key={optStatus} {...klass(className, { active: optStatus == status })}
							               onClick={doChange(optStatus)}>
								<FontAwesomeIcon icon={icon}/> <span>{text}</span>
							</Dropdown.Item>
						))}
					</Dropdown.Menu>
				</Dropdown>
				{Buttons}
		</ButtonGroup>
		}
	</ListGroupItem>
}

ItemRow.propTypes = {
	item: PropTypes.instanceOf(MenuItem),
}
